module.exports = __webpack_public_path__ + "static/media/PeakState.0a5c6f64.svg";